var icon = require('vue-svgicon')
icon.register({
  'ks-icon-chevron': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M88.48 83.79L64 59.31 39.52 83.79 32 76.21l32-32 32 32z"/>'
  }
})
